function adjustTemplateIndexPadding() {
  const header = document.getElementById('shopify-section-header-classic');
  const templatePage = document.querySelector('[id*=template-page-pf], [id*=template-index], [id*=template-collection-pf], [id*=template-collection]');

  if (!header || !templatePage) return;

  templatePage.classList.add('topped');
  templatePage.style.marginTop = `-${header.offsetHeight}px`;
  header.classList.add('transparent');
}

function updateRightOffset() {
  const currentSlide = document.querySelector('.pf-slide.is-current.is-visible');
  const rightBtn = document.querySelector('.pf-slider-next.nav-style-1');

  if (!currentSlide || !rightBtn) return;

  const slideWidth = currentSlide.offsetWidth;
  const slidePosition = currentSlide.getBoundingClientRect();
  const rightOffset = window.innerWidth - (slidePosition.left + slideWidth);
  rightBtn.style.right = `${rightOffset - rightBtn.clientWidth / 2}px`;
}

function updateCollectionSliderOffset() {
  const hasProductTemplate = Array.from(document.body.classList).some(function(className) {
    return className.includes('product');
  });

  if (!hasProductTemplate) return;

  const img = document.getElementById('offset_img');
  const collectionSlider = document.querySelector('.collection_slider');

  if (!img || !collectionSlider) return;

  collectionSlider.style.marginLeft = `${img.getBoundingClientRect().left}px`;
}

function markExternalLinks() {
  const links = document.links;

  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

function initInteractiveThemeMotion() {
  const cardSelector = '.product__grid-item, .products-slider .gallery-cell.thumbnail';
  const cartSelector = '[data-ajax-cart-trigger]';
  let observer;

  function triggerCartBounce() {
    const cartTriggers = document.querySelectorAll(cartSelector);

    cartTriggers.forEach(function(trigger) {
      trigger.classList.remove('is-cart-bouncing');
      void trigger.offsetWidth;
      trigger.classList.add('is-cart-bouncing');
    });
  }

  function prepareCard(card, index) {
    if (card.dataset.motionReady === 'true') return;

    card.dataset.motionReady = 'true';
    card.classList.add('motion-reveal');
    card.style.transitionDelay = `${Math.min(index % 6, 5) * 70}ms`;

    if (observer) {
      observer.observe(card);
    } else {
      card.classList.add('is-visible');
    }
  }

  function syncCards(root) {
    const cards = root.querySelectorAll ? root.querySelectorAll(cardSelector) : [];

    cards.forEach(function(card, index) {
      prepareCard(card, index);
    });
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -48px 0px'
    });
  }

  syncCards(document);

  if ('MutationObserver' in window) {
    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches(cardSelector)) {
            prepareCard(node, document.querySelectorAll('[data-motion-ready="true"]').length);
          }

          syncCards(node);
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('theme:cart:add', triggerCartBounce);
  window.PXUThemeInteractive = window.PXUThemeInteractive || {};
  window.PXUThemeInteractive.triggerCartBounce = triggerCartBounce;
}

document.addEventListener('DOMContentLoaded', function() {
  adjustTemplateIndexPadding();
  markExternalLinks();
  initInteractiveThemeMotion();
});

window.addEventListener('load', function() {
  if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
    updateRightOffset();
  }

  updateCollectionSliderOffset();
});

window.addEventListener('resize', adjustTemplateIndexPadding);
window.addEventListener('resize', updateRightOffset);
window.addEventListener('resize', updateCollectionSliderOffset);

/* ===== combo-filter cf-v1 (added 2026-10-16, see header below) ===== */
/*
 * combo-filter.js   build cf-v1   2026-10-16
 *
 * Velocity USA (Flex 3.5.0 theme, "Velosite/main").
 * Greys out dropdown values that do not exist for what the shopper has already
 * picked, and snaps to a real combination when a lead choice rules one out.
 * Example: Standard Disc Hub - Rear. Pick 145x10mm QR and Drilling greys out
 * 32 and 36, because only 40h exists for that axle.
 *
 * Why a separate file: the theme's own logic (app.js, shopify-variants-ui,
 * getOptionsAccessibility / _setOptionsMap) treats a value as available if ANY
 * variant uses it, regardless of the other dropdowns, so the "sold out
 * variants" setting cannot fix this. This file sits beside app.js and does not
 * modify it.
 *
 * Install: upload as assets/combo-filter.js, then in layout/theme.liquid add
 *   <script src="{{ 'combo-filter.js' | asset_url }}" defer></script>
 * directly after the existing custom_scripts.js line.
 * Check: the browser console on a product page prints "[combo-filter] cf-v1".
 *
 * Scope: dropdown style only (settings.product_form_style = "dropdown").
 * Uses variant existence only; sold-out handling stays with the theme.
 */
(function () {
  'use strict';

  var BUILD = 'cf-v1';

  // Options named here lead: they are never greyed out and the others follow
  // them. Options not named keep the product's own order after the leads.
  var LEAD_OPTIONS = ['Axle/Driver'];

  // false = grey out (works everywhere). true = also hide (iOS Safari ignores
  // hidden <option>, so greyed is the reliable default).
  var HIDE_INSTEAD_OF_DISABLE = false;

  function optionName(o) {
    return typeof o === 'string' ? o : (o && o.name) || '';
  }

  function getProduct(group) {
    var vs = null;
    if (typeof group.getVariantSelection === 'function') vs = group.getVariantSelection();
    if (!vs) vs = group.closest('variant-selection');
    if (vs && typeof vs.getProduct === 'function') {
      return Promise.resolve(vs.getProduct());
    }
    return fetch(location.pathname.replace(/\/$/, '') + '.js')
      .then(function (r) { return r.json(); });
  }

  function leadOrder(product) {
    var lead = [];
    var rest = [];
    product.options.forEach(function (o, i) {
      if (LEAD_OPTIONS.indexOf(optionName(o)) !== -1) lead.push(i); else rest.push(i);
    });
    return lead.concat(rest);
  }

  function getSelects(group) {
    var out = {};
    var list = group.querySelectorAll('select[data-variant-option]');
    for (var i = 0; i < list.length; i++) {
      var idx = parseInt(list[i].getAttribute('data-variant-option-index'), 10);
      if (!isNaN(idx)) out[idx] = list[i];
    }
    return out;
  }

  function readChosen(selects, count) {
    var chosen = [];
    for (var i = 0; i < count; i++) {
      var s = selects[i];
      chosen[i] = s && s.value && s.value !== 'not-selected' ? s.value : null;
    }
    return chosen;
  }

  // Values that exist at option order[pos], given the choices ranked before it.
  function allowedAt(product, order, pos, chosen) {
    var idx = order[pos];
    var ok = {};
    product.variants.forEach(function (v) {
      var opts = v.options || [v.option1, v.option2, v.option3];
      for (var p = 0; p < pos; p++) {
        var j = order[p];
        if (chosen[j] !== null && opts[j] !== chosen[j]) return;
      }
      ok[opts[idx]] = true;
    });
    return ok;
  }

  function apply(group, product, order) {
    var selects = getSelects(group);
    var chosen = readChosen(selects, product.options.length);
    var snapped = null;

    for (var pos = 0; pos < order.length; pos++) {
      var idx = order[pos];
      var s = selects[idx];
      if (!s) continue;
      var ok = allowedAt(product, order, pos, chosen);

      // Snap: the current pick no longer exists, so take the first value that does.
      if (chosen[idx] !== null && !ok[chosen[idx]]) {
        for (var k = 0; k < s.options.length; k++) {
          if (ok[s.options[k].value]) {
            s.value = s.options[k].value;
            chosen[idx] = s.value;
            snapped = s;
            break;
          }
        }
      }

      for (var m = 0; m < s.options.length; m++) {
        var o = s.options[m];
        if (o.value === 'not-selected') continue;
        var missing = !ok[o.value];
        o.disabled = missing;
        o.hidden = HIDE_INSTEAD_OF_DISABLE && missing;
      }
    }

    // Tell the theme the selection changed so price, button and URL update.
    if (snapped) {
      snapped.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init(group) {
    if (group.__comboFilter) return;
    group.__comboFilter = true;

    getProduct(group).then(function (product) {
      if (!product || !product.options || product.options.length < 2 || !product.variants) return;
      var order = leadOrder(product);
      var queued = false;

      var run = function () {
        if (queued) return;
        queued = true;
        // Run after the theme finishes its own rebuild of the dropdowns.
        setTimeout(function () {
          queued = false;
          apply(group, product, order);
        }, 0);
      };

      // The theme rebuilds each <select> (innerHTML then re-append) after every
      // change, which resets disabled flags, so re-apply on every rebuild.
      var selects = getSelects(group);
      Object.keys(selects).forEach(function (k) {
        new MutationObserver(run).observe(selects[k], { childList: true });
      });
      group.addEventListener('change', run);
      run();

      if (window.console) console.log('[combo-filter] ' + BUILD + ' active: ' + (product.handle || ''));
    }).catch(function (e) {
      if (window.console) console.warn('[combo-filter] ' + BUILD + ' skipped', e);
    });
  }

  function start() {
    var groups = document.querySelectorAll('options-selection');
    if (!groups.length) {
      // Fallback if the theme markup changes: one group per product form.
      var forms = [];
      var sels = document.querySelectorAll('select[data-variant-option]');
      for (var i = 0; i < sels.length; i++) {
        var f = sels[i].closest('form');
        if (f && forms.indexOf(f) === -1) forms.push(f);
      }
      groups = forms;
    }
    Array.prototype.forEach.call(groups, init);
  }

  var ready = window.customElements && customElements.get('options-selection')
    ? Promise.resolve()
    : (window.customElements ? customElements.whenDefined('options-selection') : Promise.resolve());

  var go = function () { ready.then(start); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();